export default __webpack_public_path__ + "static/media/NW0160.34I-36868_-21647_0.c5fe75cf.jpg";